import { gql } from "@apollo/client";

export const MUTATION_PAIR_TOWER_PAYMENTS_DEVICE = gql`
  mutation pairTowerPaymentsDevice(
    $pairCode: String!
    $paymentMethodId: ID!
  ) {
    pairTowerPaymentsDevice(
      pairCode: $pairCode
      paymentMethodId: $paymentMethodId
    ) {
      ... on PairedTowerPaymentsDevice {
        id
        deviceDescription
        paymentMethodId
        secret
      }
      ... on TowerPaymentsPairError {
        errorCode
        message
      }
    }
  }
`;

export const MUTATION_AUTHENTICATE_TOWER_PAYMENTS_BY_METHOD_ID = gql`
  mutation authenticateTowerPaymentsByMethodId($paymentMethodId: ID!) {
    authenticateTowerPaymentsByMethodId(paymentMethodId: $paymentMethodId) {
      ... on AuthenticatedTowerDeviceTokenResult {
        token
        tokenExpiresAt
      }
      ... on InvalidTowerPaymentsPairingError {
        errorCode
        message
      }
    }
  }
`;

export const MUTATION_REMOVE_PAIRED_TOWER_PAYMENTS_DEVICE = gql`
  mutation removePairedTowerPaymentsDevice($paymentMethodId: ID!) {
    removePairedTowerPaymentsDeviceByPaymentMethodId(
      paymentMethodId: $paymentMethodId
    ) {
      success
    }
  }
`;

export const QUERY_PAIRED_TOWER_PAYMENTS_DEVICE = gql`
  query pairedTowerPaymentsDeviceByMethodId($paymentMethodId: ID!) {
    pairedTowerPaymentsDeviceByMethodId(paymentMethodId: $paymentMethodId) {
      id
      deviceDescription
      paymentMethodId
      createdAt
    }
  }
`;

export const QUERY_TOWER_PAYMENTS_VALID_CONNECTION = gql`
  query towerPaymentsValidConnection($paymentMethodId: ID!) {
    towerPaymentsValidConnection(paymentMethodId: $paymentMethodId) {
      success
    }
  }
`;
